<div class="t-widget">
  <h3 class="t-widgetTitle">
    {{ "translate.order.orderLog" | translate }}
  </h3>
  <hr />

  <order-tracker [order]="order"></order-tracker>

  <ui-table
    *ngIf="order.activityLog && order.activityLog.length > 0"
    [isWrapped]="false"
    [dense]="true"
    [data]="order.activityLog"
    [rowHover]="false"
    [showPaginator]="false"
    [displayFilter]="isLabUser ? ['activityId', 'dateFormatted', 'activityDisplayText', 'updUserDescr'] : ['activityId', 'dateFormatted', 'activityDisplayText']"
    [scrollable]="order.activityLog.length > 4 ? true : false"
    scrollHeight="{{ order.activityLog.length > 4 ? '300px' : null }}"
    class="t-scrollbar"
  ></ui-table>

  <div *ngIf="isNew" class="disabled-area">
    <p>
      {{ "translate.order.newOrderDisabledArea" | translate }}
    </p>
  </div>
</div>
